import React, {useState} from 'react'
import {Stack, Typography} from '@mui/material'
import {STATUS} from 'src/constants/constants'
import apiClient from 'src/services/apiClient'
import Button from 'src/components-new/primitives/Button'
import InlineMessage from 'src/components-new/feedback/InlineMessage'

interface EmailSentStepProps {
  requestId: string
}

/**
 * Terminal screen for request.state === 'PATIENT_COMPILED' — new-style equivalent of the
 * legacy case in PatientDigitalEnrollment.tsx:539-551. Same pattern as
 * src/pages-new/selfRegistration/steps/ConfirmationStep.tsx: success/error feedback on
 * resend, which the legacy screen didn't have.
 */
export default function EmailSentStep({requestId}: EmailSentStepProps): JSX.Element {
  const [status, setStatus] = useState<string>()

  const handleResend = async () => {
    await apiClient.sendConfirmEmail(requestId, setStatus)
  }

  return (
    <Stack spacing={2.5} sx={{textAlign: 'center', alignItems: 'center'}}>
      <Typography variant="body1">
        {'Ti abbiamo inviato una e-mail: clicca sul link all’interno della e-mail per completare l\'adesione al programma'}
      </Typography>

      {status === STATUS.REJECTED && (
        <InlineMessage severity="error" sx={{alignSelf: 'stretch'}}>
          {"Non è stato possibile inviare nuovamente l'email. Riprova."}
        </InlineMessage>
      )}
      {status === STATUS.FULFILLED && (
        <InlineMessage severity="success" sx={{alignSelf: 'stretch'}}>
          {'Email inviata nuovamente.'}
        </InlineMessage>
      )}

      <Button variant="ghost" onClick={handleResend} loading={status === STATUS.PENDING}>
        {'Invia di nuovo'}
      </Button>
    </Stack>
  )
}
